<template>
  <div class="row text-sm text-neutral q-mb-xxl">
    <div class="col-2">
      <span class="text-neutral-80">
        {{ userDetails?.invc_id ? "Customer" : "Vendor" }}
      </span>
    </div>
    <div class="col-4">
      <span>
        {{
          (userDetails?.invc_id
            ? userDetails?.po_info?.buyer_name
            : userDetails?.seller?.[0]?.shop_name) || "-"
        }}
      </span>
      <div>
        <span class="text-xs text-neutral-70">
          {{
            userDetails?.invc_id
              ? userDetails?.po_info?.buyer_gstin
              : userDetails?.seller?.[0]?.gstin || "-"
          }}
        </span>
      </div>
    </div>
    <div class="col-2">
      <span class="text-neutral-80"> Date </span>
    </div>
    <div class="col-4">
      <span>
        {{ formatDate(userDetails?.date, "DD MMM YYYY") }}
      </span>
    </div>
    <div v-if="module === 'cn'" class="col-2">
      <span class="text-neutral-80"> Vehicle No. </span>
    </div>
    <div v-if="module === 'cn'" class="col-4">
      <span>
        {{ userDetails?.vehicle_number }}
      </span>
    </div>
    <div class="col-6"></div>
    <!-- Dispatch From -->
    <div class="col-6 q-pt-md">
      <div class="row">
        <div class="col-12">
          <span class="text-neutral-80">Dispatch From</span>
        </div>
        <div class="col-11 text-sm">
          <span>
            <template
              v-for="(line, index) in dispatchAddressLines"
              :key="`bill-${index}`"
            >
              {{ line }}
              <br v-if="index < dispatchAddressLines.length - 1" />
            </template>
          </span>
        </div>
      </div>
    </div>

    <!-- Ship To -->
    <div class="col-6 q-pt-md">
      <div class="row">
        <div class="col-12">
          <span class="text-neutral-80">Ship To</span>
        </div>
        <div class="col-11 text-sm">
          <span>
            <template
              v-for="(line, index) in shippingAddressLines"
              :key="`ship-${index}`"
            >
              {{ line }}
              <br v-if="index < shippingAddressLines.length - 1" />
            </template>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { date } from "quasar";

const { formatDate } = date;

const props = defineProps({
  userDetails: {
    type: Object,
    required: true,
  },
  source: {
    type: String,
    default: "",
  },
  module: {
    type: String,
    default: "cn",
  },
});

const formatAddressLines = (address) => {
  return typeof address === "string" ? address.split("\n") : [];
};

const dispatchAddressLines = computed(() =>
  formatAddressLines(unref(props).userDetails?.dispatch_address),
);

const shippingAddressLines = computed(() =>
  formatAddressLines(unref(props).userDetails?.shipping_address),
);
</script>
